module.exports = __webpack_public_path__ + "static/media/houtengeki.f9a11450.png";